import { createFileRoute } from "@tanstack/react-router";
import { TrikinContainer } from "../../app/views/trikin/trikinContainer";

export const Route = createFileRoute("/trikin")({
  component: TrikinContainer,
});
